<template>
  <div v-if="showAlert(alert)" class="single-alert">
    <div v-if="!isMobile()">
      <b-container class="alert-container mb-0 pt-3">
        <b-row>
          <b-col lg="1" md="1" sm="2" class="alert-icon">
            <b-img :src="require(`@/assets/${alert.type}_bigger.svg`)" />
          </b-col>
          <b-col lg="10" md="10" sm="9" class="alert-body">
            <div class="alert-title">{{ alert.title }}</div>
            <div v-html="alert.body" class="alert-text"></div>
          </b-col>
          <b-col lg="1" md="1" sm="1" class="alert-close p-0">
            <button
              v-if="alert.showClose"
              type="button"
              class="close alert-close"
              aria-label="Close"
              @click="$emit('close')"
            >
              <b-img width="16" :src="require(`@/assets/close_icon.svg`)" />
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="1" md="1" sm="2" class="alert-icon"></b-col>
          <b-col lg="11" md="11" sm="10" class="alert-body p-0">
            <b-button
              v-if="alert.btnLink"
              class="alert-button-desktop"
              type="button"
              variant="orange"
              size="md"
              :href="alert.btnLink"
              target="_blank"
            >
              {{ alert.btnTitle }}
            </b-button>
            <a
              v-if="alert.showClose"
              class="alert-link-desktop"
              href=""
              @click.prevent="disableAlert(alert.idtAffNotification)"
            >
              Fechar e não mostrar mais
            </a>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-if="isMobile()">
      <b-container class="alert-container my-3 pt-3">
        <b-row>
          <b-col class="col-2">
            <div>
              <b-img
                width="28"
                :src="require(`@/assets/${alert.type}_bigger.svg`)"
              />
            </div>
          </b-col>
          <b-col class="col-8 alert-block">
            <div class="alert-title">
              {{ alert.title }}
            </div>
            <div
              v-if="alert.mobileShowBody"
              v-html="alert.body"
              class="alert-text"
            ></div>
          </b-col>
          <b-col class="col-2">
            <button
              v-if="alert.showClose"
              type="button"
              class="close alert-close-mobile"
              aria-label="Close"
              @click="$emit('close')"
            >
              <b-img width="16" :src="require(`@/assets/close_icon.svg`)" />
            </button>
          </b-col>
        </b-row>
        <b-row v-if="alert.btnLink">
          <b-col class="col-8 alert-button-div" offset="2">
            <div class="alert-button pt-3 pb-4">
              <div>
                <b-button
                  v-if="alert.btnLink"
                  class="alert-button-title"
                  block
                  type="button"
                  variant="orange"
                  size="sm"
                  :href="alert.btnLink"
                  target="_blank"
                >
                  {{ alert.btnTitle }}
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="alert.showClose">
          <b-col class="text-right" sm="12" md="12" lg="12">
            <a
              class="alert-link"
              href=""
              @click.prevent="disableAlert(alert.idtAffNotification)"
            >
              Fechar e não mostrar mais
            </a>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import AlertApi from '@/services/alerts';
import { mapGetters } from 'vuex';
import { isMobile } from '@/utils/mobileUtils';

export default {
  name: 'AlertItem',
  props: {
    alert: Object,
  },
  computed: {
    ...mapGetters(['affiliateInfo']),
  },
  methods: {
    async disableAlert(idtAffNotification) {
      await AlertApi.disableAlert(idtAffNotification);
      this.$emit('close');
    },
    isMobile() {
      return isMobile();
    },
    showAlert(alert) {
      if (
        this.alert.btnLink !== null
        && this.alert.btnLink !== undefined
        && this.alert.btnLink !== ''
      ) {
        this.alert.btnLink = this.replaceParams(alert);
      }

      const datesToShow = 'rangeDaysToShow' in alert && alert.rangeDaysToShow != null
        ? alert.rangeDaysToShow.split('-')
        : null;
      const actualDate = new Date();
      let show = true;
      if (datesToShow !== null && datesToShow.length === 2) {
        if (
          actualDate.getDate() >= datesToShow[0]
          && actualDate.getDate() <= datesToShow[1]
        ) {
          show = true;
        } else {
          show = false;
        }
      } else if (
        datesToShow !== null
        && !datesToShow.includes(actualDate.getDate())
      ) {
        show = false;
      }
      return show;
    },
    replaceParams(alert) {
      return alert.btnLink.replace(
        '@idt_person!',
        this.affiliateInfo.idtPerson,
      );
    },
  },
};
</script>


<style lang="scss" scoped>
.alert-container {
  background: #ececec 0 0 no-repeat padding-box;
  padding: 16px;
  margin-top: 8px;
  opacity: 1;
  @media screen and (max-width: $md) {
    width: 90%;
  }
}

.alert-icon {
  padding: 0 16px;

  @media screen and (max-width: $md - 1px) {
    max-width: 13%;
  }

  @media screen and (min-width: $lg) {
    max-width: 6.5%;
  }
}

.alert-body {
  @media screen and (max-width: $md - 1px) {
    min-width: 80%;
    padding-left: 5px !important;
  }

  @media screen and (min-width: $md) {
    min-width: 86.5%;
    padding-left: 10px !important;
    padding-right: 15px !important;
  }

  @media screen and (min-width: $lg) {
    min-width: 89.5%;
    padding-left: 5px !important;
    padding-right: 0 !important;
  }

  @media screen and (min-width: $xl) {
    min-width: 89.5%;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.alert-close {
  line-height: 0;
  max-width: 1%;
}

.alert-close-mobile {
  line-height: 0;
}

.alert-block {
  padding-left: 0;
  @media screen and (max-width: $md) {
    padding-right: 0;
  }
}

.alert-title {
  font-family: UOLtext;
  margin-top: -5px;
  font-weight: bold;
  font-size: 15px;
  color: #202020;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  padding-bottom: 0.25em;
  @media screen and (max-width: $md) {
    font-size: 14px;
    margin-top: -4px;
  }
}

.alert-text {
  font-family: UOLtext;
  font-size: 14px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  color: #444444;
  padding: 0;
}

.alert-button {
  font-size: 12px;
  justify-content: space-between;
  @media screen and (max-width: $md) {
    font-size: 14px;
  }
}

.alert-button-div {
  @media screen and (max-width: $md) {
    padding: 0;
  }
}

.alert-button-desktop {
  float: left;
  height: 26px;
  padding-top: 3px;
  font-size: 12px;
  justify-content: space-between;
  @media screen and (max-width: $md) {
    font-size: 14px;
  }
  @media screen and (max-width: $md) {
    padding-top: 6px;
    height: 34px;
  }
}

.alert-button-title {
  height: 26px;
  padding-top: 3px;
  font-size: 12px;
  justify-content: space-between;
  @media screen and (max-width: $md) {
    font-size: 14px;
  }
  @media screen and (max-width: $md) {
    padding-top: 6px;
    height: 34px;
  }
}

.alert-link-desktop {
  float: right;
  font-family: UOLtext;
  font-size: 12px;
  color: #0070ab;
  opacity: 1;
  text-decoration: none;
}

.alert-link-desktop:hover {
  text-decoration: underline;
}

.alert-link {
  font-family: UOLtext;
  font-size: 12px;
  color: #0070ab;
  opacity: 1;
  text-decoration: none;
  font-weight: 100 !important;
  @media screen and (min-width: $lg) {
    position: absolute;
    bottom: 0;
    right: 0;
    white-space: nowrap;
  }
  @media screen and (max-width: $md) {
    text-decoration: underline;
  }
}
.alert-link:hover {
  text-decoration: underline;
}

a > .alert-link-body {
  font-family: UOLtext;
  font-size: 12px;
  font-weight: normal;
  color: #0070ab;
  text-decoration: none;
  opacity: 1;
}
</style>
